module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-kecsampang",
  subdomain: "kecsampang",
};
